import React, { useContext, useEffect, useRef } from "react";
import * as echarts from "echarts";
import { DataBoardContext } from "../../../index.context";

type DataType = {
  name: string
  value: number
  center?: boolean
  label?: any
}
type Props = {
  name: string
  title?: string | false
  data?: DataType[]
  series?: echarts.PieSeriesOption
}

const makeOption = ({ name, data = []}: Props)=> {
  return {
    tooltip: {
      trigger: 'item'
    },
    xAxis: {
      type: 'category',
      data: data.map(t=> t.name),
      triggerEvent: true,
      axisLabel: {
        align: 'right', // 设置标签右对齐
        verticalAlign: 'middle',
        margin: 10,    // 增加右边距使效果更明显
        rotate: 15, // 设置标签旋转45度
        interval: 0 // 强制显示所有标签
      }
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: data.map(t=> t.value),
        type: 'bar',
        markPoint: {
          data: [
            { type: 'max', name: 'Max' },
            { type: 'min', name: 'Min' }
          ]
        },
      }
    ]
  }
}

const LineChart: React.FC<Props> = ({ name, data = []})=> {

  const ctx = useContext(DataBoardContext)

  const chartRef = useRef<HTMLDivElement>(null);

  const echartsInstance = useRef<echarts.ECharts>()

  useEffect(()=> {
    if (echartsInstance.current) {
      // echartsInstance.current.clear()
      echartsInstance.current.setOption(makeOption({name, data}))
    }
  }, [data])

  useEffect(()=> {
    setTimeout(()=> {
      if (echartsInstance.current) {
        if (ctx.tabIndex === '0' || ctx.mainTabIndex == '0') {
          echartsInstance.current.resize()
        }
      }
    })
  }, [ctx.tabIndex, ctx.mainTabIndex])
  
  useEffect(()=> {
    if (chartRef.current) {
      echartsInstance.current = echarts.init(chartRef.current)
      echartsInstance.current.setOption(makeOption({name, data}))
    }
  }, [])

  return (
    <div ref={chartRef} style={{height: '100%', width: '100%'}}></div>
  )
}

export default LineChart